import { Outlet } from "react-router-dom";

const Sports = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Sports;
